import {
  Component,
  Input,
  OnInit,
  input,
  output,
  ChangeDetectionStrategy,
} from "@angular/core";
import { Subscription } from "rxjs";
import { SelectItem } from "primeng/api";
import { countryCodes } from "../../../shared/countries/country-codes.const";
import { Bind } from "primeng/bind";
import { Select } from "primeng/select";
import { FormsModule } from "@angular/forms";

export interface CountryChangeEvent {
  originalEvent: MouseEvent;
  value: string;
}

@Component({
  selector: "app-country-select",
  templateUrl: "./country-select.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [Bind, Select, FormsModule],
})
export class CountrySelectComponent implements OnInit {
  public readonly countryChange = output<string>();
  @Input() public country;
  public readonly disabled = input(false);
  public readonly required = input(true);
  public readonly placeholder = input("All");

  public subscription = new Subscription();
  public countryList: SelectItem[] = [];

  constructor() {}

  ngOnInit() {
    this.buildCountryList();
  }

  public onCountryChange(event: CountryChangeEvent) {
    this.countryChange.emit(event.value);
  }

  private buildCountryList() {
    if (this.required() === false) {
      this.countryList.push({ label: this.placeholder(), value: null });
    }
    Object.keys(countryCodes).map((key) => {
      this.countryList.push({
        label: countryCodes[key],
        value: key,
      });
    });
  }
}
